export const formatNumber = ( number ) => {
    return (number || 0).toLocaleString();
}